import React from 'react';
import { AmInput, DoubleRule } from '../shared';
import Checkbox from '../../../../components/Checkbox';
import { colors } from '../../../../colors';

export interface AccountValues {
  email: string;
  username: string;
  password: string;
  repeatPassword: string;
  termsAccepted: boolean;
}

const Account: React.FC<{
  values: AccountValues;
  onChange: <K extends keyof AccountValues>(
    key: K,
    value: AccountValues[K],
  ) => void;
  phone?: boolean;
  error?: string;
}> = ({ values, onChange, phone, error }) => {
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email);
  const usernameValid = values.username.trim().length > 0;
  const passwordsMatch =
    values.password.length > 0 && values.password === values.repeatPassword;

  return (
    <div
      style={{
        padding: phone ? '28px 20px 20px' : '48px 56px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        minHeight: 0,
      }}
    >
      <div>
        <h1
          style={{
            margin: '0 0 12px 0',
            fontSize: phone ? 34 : 56,
            fontWeight: 600,
            lineHeight: 0.95,
            letterSpacing: '-.01em',
          }}
        >
          Open the <span style={{ color: '#00B061' }}>operator</span> account.
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: 15,
            color: '#9a9a9a',
            maxWidth: 580,
            lineHeight: 1.6,
          }}
        >
          Four fields and an accepted terms box. AutoMagically only stores what
          it needs to authenticate — no KYC, no bullshit.
        </p>
      </div>
      <DoubleRule />
      <div
        className="no-scrollbar"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          overflowY: phone ? 'visible' : 'auto',
          scrollbarWidth: 'none',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: phone ? '100%' : 440,
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
          }}
        >
          <AmInput
            label="Email"
            value={values.email}
            onChange={(v) => onChange('email', v)}
            valid={emailValid}
          />
          <AmInput
            label="Username"
            value={values.username}
            onChange={(v) => onChange('username', v)}
            valid={usernameValid}
          />
          <AmInput
            label="Password"
            type="password"
            value={values.password}
            onChange={(v) => onChange('password', v)}
            valid={passwordsMatch}
          />
          <AmInput
            label="Repeat Password"
            type="password"
            value={values.repeatPassword}
            onChange={(v) => onChange('repeatPassword', v)}
            valid={passwordsMatch}
          />
          <div style={{ marginTop: 6 }}>
            <Checkbox
              label="Accept terms & privacy policy"
              value={values.termsAccepted}
              handleValueChange={(v: boolean) => onChange('termsAccepted', v)}
              color={colors.orange}
            />
          </div>
          {error && (
            <div
              style={{
                fontFamily:
                  'ui-monospace,SFMono-Regular,Menlo,Consolas,monospace',
                fontSize: 11,
                color: '#F0162F',
                letterSpacing: '.04em',
              }}
            >
              ! {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Account;
